// @flow
import { get } from "lodash";
import type { RaceProgram } from "@tvg/types/Race";
import type { UserOptedInPromos } from "@tvg/types/User";

export const isOptedInPromoRace = (
  currentRace: RaceProgram,
  optedInPromos: UserOptedInPromos
) =>
  get(currentRace.promo, "isAboveTheLine", false) &&
  !!optedInPromos[get(currentRace.promo, "rootParentPromoID")];

export default { isOptedInPromoRace };
